"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutationDelete = void 0;
const useMutation_1 = require("./useMutation");
function useMutationDelete(mutation, options) {
    return useMutation_1.useMutation(mutation, Object.assign({ update: (cache, { data }) => {
            if (data && data["__typename"] && data["id"]) {
                cache.evict({
                    id: cache.identify({
                        __typename: data["__typename"],
                        id: data["id"],
                    }),
                });
            }
        } }, options));
}
exports.useMutationDelete = useMutationDelete;
//# sourceMappingURL=useMutationDelete.js.map